import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import *  as moment from 'moment';
import { Moment } from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-mfcustom-datetime-popup',
  templateUrl: './mfcustom-datetime-popup.component.html',
  styleUrls: ['./mfcustom-datetime-popup.component.css']
})
export class MFCustomDatetimePopupComponent implements OnInit {
  private _date: Moment =  moment();
  private _time: Moment =  moment();
  public get date() {
    return this._date;
  }
  public set date(val) {
    this._date = val;
  }
  public get time() {
    return this._time;
  }
  public set time(val) {
    this._time = val;
  }
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef?: MatDialogRef<MFCustomDatetimePopupComponent>, private messageService?: ToastrService) {
    debugger;
    this.date = moment(data.date);
    this.time = moment(data.date);
  }

  ngOnInit() {
  }

  public save() {
    var date = this.date.toDate();
    var utc = moment().toDate();
    var selDate = moment.utc(`${date.getFullYear()}-${date.getMonth() + 1 < 10 ? '0' : ''}${date.getMonth() + 1}-${date.getDate()} ${this.time.hour()}:${this.time.minute()}`, "YYYY-MM-DD HH:mm Z")
    var curDate = moment.utc(`${utc.getFullYear()}-${utc.getMonth() + 1 < 10 ? '0' : ''}${utc.getMonth() + 1}-${utc.getDate()} ${utc.getHours()}:${utc.getMinutes()}`, "YYYY-MM-DD HH:mm Z")
    if (curDate.isBefore(selDate)) {
      this.date = moment();
      this.time = moment();
      this.messageService.error("Date cannot be in the future", "Incorrect date");
    }
    else this.dialogRef.close(selDate);
  }
  public close() {

    this.dialogRef.close();
  }

}
